<div  *ngIf="visible" class="signature" [style.width.px]="calculate(width)" [style.height.px]="calculate(height)" >
<img  [src]="value ? value : '../assets/images/No-Signature.jpg'"
 [style.width.px]="width" [style.height.px]="height">
    <div class="clear-box"><button class="btn btn-outline-danger" *ngIf="!readonly" (click)="setSignatureClick()"><i class="fas fa-plus"></i></button></div>
</div>  

